import type { Query } from '@Types/Base';

/**
 * Cuts out region slug from a pathname
 */
function cutOutRegionSlug(pathname: string, request: Query) {
  const { allRegions } = request;

  return (
    pathname
      .split('/')
      .filter((chunk) => !allRegions.includes(chunk))
      .join('/') || '/'
  );
}

export default cutOutRegionSlug;
